// src/app/components/shared/chip.tsx
//
// -- Migrated onto the kit, Phase 6 ------------------------------------------
//
// This replaces `components/ui/badge.tsx`, shadcn's Badge, which was used
// twenty times as "a small rounded label" with its colour typed at the call
// site — `backgroundColor: var(--infrared-coral)`, `color: var(--signal-blue)`,
// `borderColor: var(--success-border)` and so on, none of which had a dark
// form and two of which named tokens that do not exist.
//
// Kit 04 item 92's rule is the one that matters here: **tinted fill, never
// solid**, and one meaning per chip. So the chip takes a TONE from a closed
// set and paints itself from the status tokens. A caller cannot give it a
// colour, which is the whole point: the twenty call sites disagreed about what
// red meant.
//
// The kit's own chips (`RankChip`, `Badge`, `ImpactChip`, `EffortChip`,
// `ActionChip`) each derive their label from a closed union and are the right
// answer wherever the product's value IS one of those unions. This is for the
// remainder: a short label the product wants to set apart, with a tone that
// says how to read it.
import type { ReactNode } from "react";
import { cx } from "../kit";

export type ChipTone = "neutral" | "brand" | "ok" | "warn" | "error" | "info";

const STATUS: ReadonlySet<ChipTone> = new Set(["ok", "warn", "error", "info"]);

export function Chip({
  tone = "neutral", children, className,
}: { tone?: ChipTone; children: ReactNode; className?: string }) {
  return (
    <span
      className={cx("k-chip", STATUS.has(tone) && "k-chip--status", className)}
      data-tone={tone}
    >
      {children}
    </span>
  );
}
